// components/Loading/LoadingScreen.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import { BeatLoader } from 'react-spinners';

const LoadingScreen = () => {
  return (
    <Box 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: '#f5f5f5' 
      }}
    >
      <BeatLoader color="#1976d2" size={15} margin={5} />
      <Typography variant="h6" sx={{ mt: 2, color: '#1976d2' }}>
        Loading, please wait...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
